import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';
import { MarketingConsentModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: MarketingConsentModel | undefined };

const initialState: State = { state: 'valid', data: undefined };

@Injectable()
export class MarketingConsentStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'valid', data: undefined }));
  readonly setDataValid = this.updater<MarketingConsentModel>((_, data) => ({
    state: 'valid',
    data: MarketingConsentModel.fromJson(data),
  }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
